import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase/client";
import { useQueryClient } from "@tanstack/react-query";
import { authKeys } from "@/hooks/useAuth";

export function Settings() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  async function handleSignOut() {
    await supabase.auth.signOut();
    queryClient.setQueryData(authKeys.session(), null);
    navigate("/", { replace: true });
  }

  return (
    <main
      className="flex min-h-screen flex-col px-6 pt-10"
      style={{ background: "#FFFCF8", color: "#1A1620" }}
    >
      <h1 className="font-display text-3xl" style={{ color: "#8A4E9C" }}>
        Settings
      </h1>
      <p className="mt-2 text-sm" style={{ color: "#9A8A78" }}>
        More settings arrive in Week 5.
      </p>
      <button
        type="button"
        onClick={handleSignOut}
        className="mt-10 self-start rounded-full px-5 py-2 text-sm font-medium"
        style={{ border: "1px solid #EAE4DA", background: "#FFFFFF", color: "#A05A38" }}
      >
        Sign out
      </button>
    </main>
  );
}
